let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("b5Q7f")]).then(() => parcelRequire('aVMo3'));